import { useEffect, useState } from 'react';
import { useAuthData } from '~/hooks/auth/use-auth-data';
import { useProjectId } from '~/hooks/context/useProjectId';
import HyperDX from '@hyperdx/browser';
import { env } from '~/env.mjs';

function getDeploymentEnvironment() {
  const vercelEnv = env.NEXT_PUBLIC_VERCEL_ENV;
  if (vercelEnv === 'preview') {
    return 'staging';
  }
  return vercelEnv ?? 'unknown';
}

export function HyperDXProvider() {
  const projectId = useProjectId();
  const { user } = useAuthData();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (projectId && user && isInitialized) {
      HyperDX.setGlobalAttributes({
        userId: user.userId,
        userEmail: user.email,
        userName: `${user.firstName} ${user.lastName}`,
        teamId: projectId,
        'deployment.environment': getDeploymentEnvironment(),
      });
    }
  }, [user, projectId, isInitialized]);

  useEffect(() => {
    if (env.NEXT_PUBLIC_HYPERDX_API_KEY) {
      try {
        HyperDX.init({
          apiKey: env.NEXT_PUBLIC_HYPERDX_API_KEY,
          service: 'stably-frontend',
          tracePropagationTargets: [/api\.stably\.ai/i, /.*\.stably\.dev/i, /localhost:3000/i],
          sampling: {
            mousemove: 1_000, // record mouse events every 1s
            scroll: 500, // record scroll events every 500ms
          },
        });
        setIsInitialized(true);
      } catch (error) {
        console.error('Failed to initialize HyperDX:', error);
      }
    }
  }, []);

  return null;
}
